import ActionableTextSnippet from "snippets/actionable-text.mdx";
import ButtonSizeSnippet from "snippets/button-size.mdx";
import * as React from 'react';
export default {
  ActionableTextSnippet,
  ButtonSizeSnippet,
  React
};